export class Org {
    certified: number;
    certified_time: string;
    industry: number;
    licence_code: string;
    licence_image: string;
    name: string;
    note: string;
    id: string;
    scale: number;
    secret: string;
    key: string;
}

export class AttachOrg {
    party_id: string;
    party_type: string;  // personal | organization
    party_name: string;
}

export class OrgUser {
    create_time: string;
    nickname: string;
    real_name: string;
    user_id: string;
    username: string;
    mobile: string;
    email: string;
    user_role: number;
    sex: number;
}
